import React from 'react';
// @ts-ignore
import styles from './PatientPsychoQuestionnaireWarning.module.scss';
import { useLoadProfile } from '../../../../Components/PatientProfile/PatientProfileDataLoader';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	patientId: string;
}

const PatientPsychoQuestionnaireWarning: React.FC<Props> = ({ patientId }) => {
	const { globalTemplate } = useAppContext();
	const showCzechServices = globalTemplate === 'default';
	const { psychoQuestionnaire, psychoQuestionnaireTheme }: any = useLoadProfile(
		{
			userId: patientId,
			loadVerifyInformation: showCzechServices,
			loadUserRelations: false,
			loadHealthCard: false,
		},
	);

	if (!psychoQuestionnaire || !psychoQuestionnaireTheme) {
		return <></>;
	}

	return (
		<div className={styles.item}>
			<div className={styles.value}>
				<div className={'text-' + psychoQuestionnaireTheme}>
					<i
						className={
							'fa fa-' +
							psychoQuestionnaire?.fontIcon +
							' fa-fw mr-1 text-' +
							psychoQuestionnaireTheme
						}></i>
					{psychoQuestionnaire?.title}
				</div>
			</div>
		</div>
	);
};

export default PatientPsychoQuestionnaireWarning;
